
const universalText = /^[a-zA-Z'\- \u00c0-\u017e]+$/;

interface AppRegExp {
  alphabet: RegExp
  email: RegExp
  name: RegExp
  lastName: RegExp
  identification: RegExp
  phone: RegExp
  onlyValidGrade: RegExp
}

export const regExp: AppRegExp = {
  alphabet: /^[a-zA-ZáÁÉéíÍóÓúÚñÑ]$/,
  email: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
  name: universalText,
  lastName: universalText,
  identification: /^[a-zA-Z0-9]+$/,
  phone: /^(\+\d{1,3}\s)?\d{2,4}[\s.-]?\d{6,8}$/,
  onlyValidGrade: /^(?:[1-9]|0[1-9]|10|(^$))(\.[0-9]{0,2})?$/
}

export default regExp;
